import { SupermarketPreferences } from "@/clients/models/SupermarketPreferences";
import { SupermarketService } from "@/clients/services/SupermarketService";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation } from "@tanstack/react-query";

export const useUpdateSupermarketPreferences = () => {
  const { mutate, isPending, isError, error } = useMutation({
    mutationFn: async (preferences: SupermarketPreferences) => {
      const user = guardGetUserFromLocalStorage();
      const { data } =
        await SupermarketService.updateSupermarketPreferencesApiV1SupermarketsPreferencesPut(
          user.id,
          preferences,
        );
      return data;
    },
  });
  return {
    updateSupermarketPreferences: mutate,
    isUpdating: isPending,
    isError,
    error,
  };
};
